import { render, staticRenderFns } from "./MIdentityTracking.vue?vue&type=template&id=bf1cd476&lang=pug&"
import script from "./MIdentityTracking.vue?vue&type=script&lang=js&"
export * from "./MIdentityTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports